import { render } from "./VariantColor.vue?vue&type=template&id=5c9137f2&lang=pug"
import script from "./VariantColor.vue?vue&type=script&lang=js"
export * from "./VariantColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__